import OverviewRoute from "@/routes/processes/[processId]/rlt/overview/overview";
import ContactRoute from "@/routes/processes/[processId]/rlt/contact/contact";
import { Navigate, Outlet, RouteObject } from "react-router";
import { WorkOrdersRoute } from "@/routes/processes/[processId]/rlt/work-orders/work-orders-route";
import { calculationsRoutes } from "@/routes/processes/[processId]/rlt/calculations/calculations-routes";
import { rltOffersRoutes } from "@/routes/processes/[processId]/rlt/offers/offers-routes";
import { certificatesRoutes } from "@/routes/processes/[processId]/rlt/certificates/certificates-routes";
import { confirmationsRoutes } from "@/routes/processes/[processId]/rlt/confirmations/confirmations-routes";
import { workOrdersRoutes } from "@/routes/processes/[processId]/rlt/work-orders/work-orders-routes";
import { rltOrdersRoutes } from "@/routes/processes/[processId]/rlt/orders/orders-routes";
import { commitmentsRoutes } from "@/routes/processes/[processId]/rlt/commitments/commitments-routes";
import { ProcessConfiguredGuard } from "../_components/process-configured-guard";

export const rltRoutes: RouteObject[] = [
  {
    element: <Navigate to="overview" replace />,
    index: true,
  },
  {
    path: "overview",
    element: <OverviewRoute />,
  },
  {
    path: "contact",
    element: <ContactRoute />,
  },
  // The following routes require a fully configured process.
  // The elements are wrapped with an appropriate guard, to
  // notify the user.
  ...[
    {
      path: "calculations",
      element: <Outlet />,
      children: calculationsRoutes,
    },
    {
      path: "commitments",
      element: <Outlet />,
      children: commitmentsRoutes,
    },
    {
      path: "offers",
      element: <Outlet />,
      children: rltOffersRoutes,
    },
    {
      path: "orders",
      element: <Outlet />,
      children: rltOrdersRoutes,
    },
    {
      path: "confirmations",
      element: <Outlet />,
      children: confirmationsRoutes,
    },
    {
      path: "work-orders",
      element: <WorkOrdersRoute />,
      children: workOrdersRoutes,
    },
    {
      path: "certificates",
      element: <Outlet />,
      children: certificatesRoutes,
    },
  ].map((route) => ({
    ...route,
    element: <ProcessConfiguredGuard>{route.element}</ProcessConfiguredGuard>,
  })),
];
